import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { selectWishListQuantity } from '../Selectors/wishlist-selectors';

export default function FavouriteIcon() {

    const quantity = useSelector(selectWishListQuantity)

    return (
        <>
            <i className="fal fa-bookmark">{quantity > 0 && <span className="cart__quantity">{quantity}</span>}</i>
            <span className="profile__title">{translate('wishlist.title')}</span>
        </>
    )
}